import { i as page } from './index2.js';
import 'tty';
import 'os';
import 'deepmerge';
import 'axios';
import 'vue';
import { n as normalizeComponent } from './normalize-component.js';

//
var script = {
  mixins: [page],
  data: function data() {
    return {
      answerSectionID: null
    };
  },
  mounted: function mounted() {// TODO: if (!settings.repeatMultipleChoiceQuestions) this.answerSectionID = getItFromStore
  },
  methods: {
    selectAnswer: function selectAnswer(sectionID) {
      this.answerSectionID = sectionID; // TODO: save Answer to store
    }
  }
};

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c(
    "div",
    { staticClass: "c-multiple-choice-page" },
    [
      _c(
        "div",
        { staticClass: "c-multiple-choice-page__question" },
        [
          _vm._l(_vm.pageData.Sections[0].entries, function(entry) {
            return _c("dynamic-entry", {
              key: entry.ID,
              attrs: { entryData: entry, id: "entry-" + entry.ID }
            })
          }),
          _vm._v(" "),
          _vm.answerSectionID == null
            ? _c(
                "ul",
                { staticClass: "c-multiple-choice-page__answers" },
                _vm._l(
                  _vm.pageData.Sections.filter(function(item, index) {
                    return index > 0 && item.Title > ""
                  }),
                  function(section) {
                    return _c("li", { key: section.ID }, [
                      _c(
                        "button",
                        {
                          staticClass: "c-multiple-choice-page__answer",
                          on: {
                            click: function($event) {
                              return _vm.selectAnswer(section.ID)
                            }
                          }
                        },
                        [
                          _c("span", {
                            staticClass: "xp xp--medium xp-arrow-forward"
                          }),
                          _c("span", { staticClass: "question-title" }, [
                            _vm._v(_vm._s(section.Title))
                          ])
                        ]
                      )
                    ])
                  }
                ),
                0
              )
            : _vm._e()
        ],
        2
      ),
      _vm._v(" "),
      _vm._l(
        _vm.pageData.Sections.filter(function(item, index) {
          return index > 0 && item.Title > ""
        }),
        function(sectionData) {
          return _c(
            "div",
            {
              key: sectionData.ID,
              staticClass: "o-section",
              class: {
                answer: true,
                selected: sectionData.ID == _vm.answerSectionID
              }
            },
            [
              _c("div", { staticClass: "c-multiple-choice-page__answer" }, [
                _c("span", { staticClass: "question-title" }, [
                  _vm._v(_vm._s(sectionData.Title))
                ])
              ]),
              _vm._v(" "),
              _vm._l(sectionData.entries, function(entry) {
                return _c("dynamic-entry", {
                  key: entry.ID,
                  attrs: { entryData: entry, id: "entry-" + entry.ID }
                })
              })
            ],
            2
          )
        }
      )
    ],
    2
  )
};
var __vue_staticRenderFns__ = [];
__vue_render__._withStripped = true;

  /* style */
  const __vue_inject_styles__ = undefined;
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  );

export default __vue_component__;
//# sourceMappingURL=XpMultipleChoicePage.js.map
